<template>
  <div class="container">
    <div class="callback-card">
      <div class="line-logo">LINE</div>
      <h1 class="page-title" id="page-title">LINE 登入處理</h1>
      <p class="app-name" id="app-name">我的應用程式</p>

      <!-- 載入狀態 -->
      <div v-if="isLoading" class="status-section">
        <div class="loading-spinner"></div>
        <div class="status-message">
          {{ processingMessage }}
        </div>
        <div class="status-description">請稍候，我們正在驗證您的登入資訊</div>
      </div>

      <!-- 成功狀態 -->
      <div v-if="isSuccess" class="status-section">
        <div class="status-icon status-success">✓</div>
        <div class="status-message">
          {{ successMessage }}
        </div>
        <div class="status-description">您已成功通過 LINE 登入驗證</div>

        <div class="user-info" v-if="userInfo">
          <div class="user-avatar">
            {{ userInfo.avatar }}
          </div>
          <div class="user-name">
            {{ userInfo.name }}
          </div>
          <div class="user-id">
            {{ userInfo.id }}
          </div>
        </div>

        <div class="auth-details">
          <div class="auth-row">
            <span class="auth-label">授權碼：</span>
            <span class="auth-value">{{ callbackData.code || "-" }}</span>
          </div>
          <div class="auth-row">
            <span class="auth-label">狀態：</span>
            <span class="auth-value">{{ callbackData.state || "-" }}</span>
          </div>
          <div class="auth-row">
            <span class="auth-label">時間：</span>
            <span class="auth-value">{{ authTime }}</span>
          </div>
        </div>
      </div>

      <!-- 錯誤狀態 -->
      <div v-if="isError" class="status-section">
        <div class="status-icon status-error">✕</div>
        <div class="status-message">
          {{ errorMessage }}
        </div>
        <div class="status-description">登入過程中發生錯誤</div>

        <div class="error-details">
          <div class="error-code">錯誤代碼：{{ errorData.code }}</div>
          <div class="error-description">
            {{ errorData.description }}
          </div>
        </div>
      </div>

      <!-- 操作按鈕 -->
      <div v-if="showActions" class="actions">
        <button class="btn btn-primary" @click="continueToApp">
          {{ continueButtonText }}
        </button>
        <button v-if="isError" class="btn btn-secondary" @click="retryLogin">
          重新登入
        </button>
      </div>
    </div>
  </div>
</template>

<script src="@/assets/js/linecallback.js"  defer></script>
<style scoped src="@/assets/css/linecallback.css"></style>
